import BulkEdit from './BulkEdit'

export default BulkEdit
